import Vue from 'vue'
import { createInertiaApp, InertiaLink } from '@inertiajs/inertia-vue'
import { InertiaProgress } from '@inertiajs/progress'
import VueMeta from 'vue-meta'
import PortalVue from 'portal-vue'
// import { InertiaApp } from '@inertiajs/inertia-vue'
import axios from 'axios'
import moment from 'moment-timezone'
import wysiwyg from "vue-wysiwyg"
import vSelect from 'vue-select'

let token = document.head.querySelector('meta[name="csrf-token"]');

Vue.config.productionTip = false
Vue.prototype.$http = axios.create({
  headers: {
    'X-Requested-With': 'XMLHttpRequest',
    'X-CSRF-TOKEN': token.content
  }
});


Vue.mixin({ methods: {
    route: window.route,
    canAdmin: function (permission) {
      if (Array.isArray(permission)) {
        return permission.some(perm => this.$page.props.can.indexOf('admin-' + perm) >= 0)
      } else {
        return this.$page.props.can.indexOf('admin-' + permission) >= 0;
      }
    }
}})

// Vue.use(InertiaApp)
Vue.use(PortalVue)
Vue.use(VueMeta)
Vue.use(wysiwyg, {});

Vue.filter('localDateTime', function (value) {
  return moment(value).local().format('DD/MM/YYYY LTS')
})

Vue.filter('localDate', function (value) {
  return moment(value).local().format('DD/MM/YYYY')
})

Vue.filter('localDateWithWeekDay', function (value) {
  return moment(value).local().format('DD/MM/YYYY - dddd')
})

Vue.component('v-select', vSelect)
Vue.component('InertiaLink', InertiaLink)

InertiaProgress.init({
  // The delay after which the progress bar will
  // appear during navigation, in milliseconds.
  delay: 250,

  // The color of the progress bar.
  color: '#29d',

  // Whether to include the default NProgress styles.
  includeCSS: true,

  // Whether the NProgress spinner will be shown.
  showSpinner: false,
})

// let app = document.getElementById('app')

// new Vue({
//   metaInfo: {
//     titleTemplate: (title) => title ? `${title}` : 'APP'
//   },
//   render: h => h(InertiaApp, {
//     props: {
//       initialPage: JSON.parse(app.dataset.page),
//       resolveComponent: name => import(`@/Pages/${name}`).then(module => module.default),
//     },
//   }),
// }).$mount(app)

createInertiaApp({
  resolve: name => require(`./Pages/${name}`),
  setup({ el, app, props }) {
    new Vue({
      metaInfo: {
        titleTemplate: (title) => title ? `${title}` : 'APP',
      },
      render: h => h(app, props),
    }).$mount(el)
  },
})

// createInertiaApp({
//   resolve: name => require(`./Pages/${name}`),
//   setup({ el, App, props }) {
//     new Vue({
//       render: h => h(App, props),
//     }).$mount(el)
//   },
// })
